const DragDropType={STREET_VIEW_BUTTON:'streetViewButton'};
export default DragDropType;		